<template>
  <h2 class="gradation">Podcast最新のエピソード</h2>
  <div class="overflow-hidden rounded-lg elevation-2 bg-white">
    <v-img v-if="podcastImg" :src="podcastImg"></v-img>
    <v-img v-else :src="'/images/top/banner-01.webp'"></v-img>
    <div class="pa-3">
      <div class="mb-3">{{ podcastTitle }}</div>
      <v-btn @click="playPodcast" color="primary" variant="tonal" class="rounded-pill" block>再生する</v-btn>
    </div>
  </div>
</template>

<script setup> 
import { ref, onMounted, inject } from 'vue';
import axios from 'axios';

const podcastIframe = ref('');
const podcastTitle = ref('');
const podcastImg = ref('');

// 非同期データ取得メソッド
const fetchContent = async () => {
  try {
    const res = await axios.get('/api/podcast/newer');
    podcastIframe.value = res.data.iframe;
    podcastTitle.value = res.data.head;
    podcastImg.value = res.data.img;
  } catch (error) {
    console.error("Error fetching content:", error);
  }
}

onMounted(fetchContent); // コンポーネントがマウントされたときに非同期データを取得

const podcastPlay = inject('setPodcast');
const playPodcast = () => {
  podcastPlay(podcastIframe.value, podcastTitle.value);
}

</script>